export const getThumbnailPath = (originalPath, size = "md") => {
  const pathParts = originalPath.split("/");
  const fileName = pathParts[pathParts.length - 1];
  const fileNameWithoutExt = fileName.split(".")[0];
  const ext = fileName.split(".")[1];
  return `/thumbnails/${fileNameWithoutExt}-${size}.${ext}`;
};
